import WebpImage from "@al/rc-webp-image";
export default WebpImage;